import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { PrivateAxios } from '../../../environment/AxiosInstance';
import { SuccessMessage, ErrorMessage } from '../../../environment/ToastMessage';

function DeleteTaskModal({ show, handleClose, task, onUpdated }) {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!task?.id) return;

    //if (!window.confirm("Are you sure you want to delete this task?")) return;

    setLoading(true);
    try {
      await PrivateAxios.put(`/projecttasks/${task.id}/delete`);

      if (onUpdated) onUpdated(); // refresh the parent task list
      handleClose();
      SuccessMessage("Task deleted successfully");
    } catch (error) {
      console.error("❌ Delete error:", error);
      ErrorMessage(error.response?.data?.message || "Failed to delete task");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton className="gth-light-red-bg">
        <Modal.Title className="gth-text-danger">Delete Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="delete-confirm-wrap text-center">
          <div className="delete-confirm-icon mb-3 mt-2">
            <img
              src={process.env.PUBLIC_URL + '/assets/images/delete-warning.svg'}
              alt="Warning"
              className="img-fluid"
            />
          </div>
          <h4 className="text-muted">Are you sure?</h4>
          <p className="text-muted">
            Do you really want to delete this record? (It will be soft deleted)
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className='justify-content-center'>
        <button className='btn btn-secondary' onClick={handleClose} disabled={loading}>
          Cancel
        </button>
        <button className='btn btn-exp-red' onClick={handleDelete} disabled={loading}>
          {loading ? "Deleting..." : "Delete"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteTaskModal;
